<template>
  <div class="consulting">
    <div
      class="consulting__hero"
      style="background-image: url('/images/consulting/bg-hero-heumtax.jpg');"
    >
      <div class="consulting__hero-container">
        <div class="consulting__hero-contents">
          <div class="consulting__hero-title">상담 신청하기</div>
          <p class="consulting__hero-description">
            전화번호를 남겨주시면 전문 세무사들이 직접 상담을 도와드립니다.
          </p>
        </div>
      </div>
    </div>
    <ValidationObserver ref="form">
      <form @submit.prevent="onSubmit" class="form">
        <input id="uuid" v-model="uuid" hidden />

        <ValidationProvider
          v-slot="{ errors }"
          name="상담유형 "
          mode="lazy"
          rules="required"
          slim
        >
          <div class="form__field">
            <label class="label label--required" for="phone_number"
              >상담유형</label
            >
            <label
              :class="{
                'radio-box--selected': lead_type === 'biz'
              }"
              class="radio-box"
            >
              <input
                v-model="lead_type"
                value="biz"
                class="radio-box__input"
                type="radio"
                name="상담유형"
              />
              <div class="radio-box__circle"></div>
              <div class="radio-box__content">
                <div class="radio-box__title">사업 관련 세무상담</div>
                <p class="radio-box__description">
                  사업자 또는 사업을 준비 중입니다.
                </p>
              </div>
            </label>
            <label
              :class="{
                'radio-box--selected': lead_type === 'general'
              }"
              class="radio-box"
            >
              <input
                v-model="lead_type"
                value="general"
                class="radio-box__input"
                type="radio"
                name="상담유형"
              />
              <div class="radio-box__circle"></div>
              <div class="radio-box__content">
                <div class="radio-box__title">기타 세무상담</div>
                <p class="radio-box__description">
                  양도, 상속, 증여, 비사업자 세무상담입니다.
                </p>
              </div>
            </label>
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
          </div>
        </ValidationProvider>

        <ValidationProvider
          v-slot="{ errors }"
          name="전화번호 "
          mode="lazy"
          rules="required|numeric|min:7"
          slim
        >
          <div class="form__field">
            <label class="label label--required" for="phone_number"
              >전화번호</label
            >
            <input
              id="phone_number"
              v-model="phone"
              class="input"
              name="phone_number"
              type="tel"
              placeholder="전화번호를 입력해주세요."
            />
            <p class="validation-msg">
              {{ errors[0] }}
            </p>
          </div>
        </ValidationProvider>

        <div class="form__field">
          <button type="submit" class="btn btn--primary form__submit">
            상담 신청하기
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import consulting from '~/components/mixins/consulting.js'

export default {
  layout: 'invert-font-header',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [consulting],
  data() {
    return {
      phone: '',
      lead_type: ''
    }
  },
  methods: {
    async consultationRequest() {
      this.$nuxt.$loading.start()

      await this.requestLeadApi('post', 'online', {
        phone: this.phone,
        ga_code: this.uuid,
        lead_type: this.lead_type,
        ...this.utmParams
      }).then((res) => {
        // 페이지가 새로고침 되거나 해도 유지되게 하기 위해 localStorage 사용
        localStorage.setItem('personId', res.person_id)
        localStorage.setItem('dealId', res.deal_id)
        localStorage.setItem('noteId', res.note_id)
      })

      this.$nuxt.$loading.finish()

      // leadType은 광고 최적화를 위한 파라미터
      await this.$router.push({
        path: '/consulting-detail',
        query: { leadType: this.lead_type }
      })

      return Promise.resolve()
    }
  }
}
</script>
